import type { WorkspaceKey } from '@festina-life/api'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { isEqualWorkspace } from '../../../../workspace/helpers'
import { useWorkspaceManagerContext } from '../../../../workspace/workspaceManagerContext'

export const useOpenWorkspace = (nextWorkspaceKey: WorkspaceKey) => {
  const [didChangeWorkspace, setDidChangeWorkspace] = useState(false)
  const { onSwitch, currentWorkspaceKey } = useWorkspaceManagerContext()
  const isWorkspaceOpen = isEqualWorkspace(
    nextWorkspaceKey,
    currentWorkspaceKey,
  )
  const isWorkspaceLoading = didChangeWorkspace && !isWorkspaceOpen

  useEffect(() => {
    if (didChangeWorkspace && isWorkspaceOpen) {
      setDidChangeWorkspace(false)
    }
  }, [didChangeWorkspace, isWorkspaceOpen])

  const handleNavigateToWorkspace = useCallback(() => {
    void onSwitch(nextWorkspaceKey)
    setDidChangeWorkspace(true)
  }, [nextWorkspaceKey, onSwitch])

  return useMemo(
    () => ({
      mutateAsync: handleNavigateToWorkspace,
      isLoading: isWorkspaceLoading,
    }),
    [handleNavigateToWorkspace, isWorkspaceLoading],
  )
}
